import React from 'react'
import './FileInput.scss'

export default ({ label, name, id, onChange, errorMessage }) => {

    return (
        <div className="hds-input-group">
            <label for={name} className='hds-input-group__label'>
                {label}
            </label>
            <div className="">
                <input
                    type='file'
                    id={id}
                    className='fileInput'
                    name={name}
                    onChange={onChange}
                    accept='image/*, .doc, .docx,application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf '
                />
                {errorMessage && (
                    <div className='fileInput-error hds-error-message'>
                        {errorMessage}
                    </div>
                )}
            </div>
        </div>
    )
}
